import styled from 'styled-components';
import PropTypes from 'prop-types';

const InputIcon = styled.span`
	display: block;
  position: absolute;
  width: 20px;
  height: 20px;
  left: -30px;
  top: 35px;
  background: url(${props => props.url}) no-repeat 50%;
`;

InputIcon.propTypes = {
	url: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired
};

export default InputIcon;
